
/** 
* This file has been auto-generated by '@kontent-ai/model-generator@8.1.1'.
* 
* (c) Kontent.ai
*  
* -------------------------------------------------------------------------------
* 
* Project: UnumUK Employer Portal
* Environment: Dev (Previously Phase 2)
* Id: a5beabf7-cb3f-0126-9900-a0a631d69346
* 
* -------------------------------------------------------------------------------
**/

import type { Elements } from "@kontent-ai/delivery-sdk";
import type { CoreContentType } from "../system/index.js";
import type { Icons, Products, Roles } from "../taxonomies/index.js";
import type { NavInternalLink, NavExternalLink, NavSubItem } from "./index.js";

/**
 * 🔗 Nav // Menu Item Group
 *
 * Id: 585c8c87-4fd8-48cf-9eec-405c4e086a0a
 * Codename: menu_item_group
 */
export type NavMenuItemGroup = CoreContentType<
  NavMenuItemGroupElementCodenames,
  {
    /**
     * Icons
     *
     * Type: taxonomy
     * Required: true
     * Codename: icon
     * Id: 929a251d-a13d-4572-a901-82f51ad59285
     */
    readonly icon: Elements.TaxonomyElement<Icons, "icon">;
    /**
     * Label
     *
     * Type: text
     * Required: true
     * Codename: label
     * Id: b3e423c8-ceb4-4d14-a2e8-e9f6314af225
     */
    readonly label: Elements.TextElement;
    /**
     * Children
     *
     * Type: modular_content
     * Required: true
     * Codename: children
     * Id: c1404092-e096-49d0-a417-30d7cd6c5ba8
     */
    readonly children: Elements.LinkedItemsElement<
      NavInternalLink | NavExternalLink | NavSubItem
    >;
    /**
     * Products
     *
     * Type: taxonomy
     * Required: false
     * Codename: products
     * Id: e95d1237-6a5f-4c9e-a2df-c09e17a655af
     * Guidelines: • Restrict the visibility of this content to selected products. • If no products are selected, the content will be visible to all users.
     */
    readonly products: Elements.TaxonomyElement<Products, "products">;
    /**
     * Roles
     *
     * Type: taxonomy
     * Required: false
     * Codename: roles
     * Id: 5bfdd7f3-c98f-4f1c-aeaf-a835cc8ea9ce
     * Guidelines: • Restrict the visibility of this content to users with selected roles. • If no roles are selected, the content will be visible to all users.
     */
    readonly roles: Elements.TaxonomyElement<Roles, "roles">;
  },
  "menu_item_group"
>;

/**
 * Type representing all available element codenames for 🔗 Nav // Menu Item Group
 */
export type NavMenuItemGroupElementCodenames =
  | "icon"
  | "label"
  | "children"
  | "products"
  | "roles";

/**
 * Type guard for 🔗 Nav // Menu Item Group
 *
 * Id: 585c8c87-4fd8-48cf-9eec-405c4e086a0a
 * Codename: menu_item_group
 */
export function isNavMenuItemGroup(item: CoreContentType | undefined | null): item is NavMenuItemGroup {
    return item?.system?.type === 'menu_item_group';
}
